import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { NgClass, NgIf } from '@angular/common'
import { CnpjPipe } from '../../pipes/cpnj.pipes'
import { CpfPipe } from '../../pipes/cpf.pipes'
import { TelefonePipe } from '../../pipes/phone.pipes'
import { MatIconModule } from '@angular/material/icon'

@Component({
  selector: 'table-list-tariff-select',
  imports: [
    MatTableModule,
    MatIconModule,
    NgIf,
    CnpjPipe,
    CpfPipe,
    TelefonePipe,
    NgClass,
  ],
  templateUrl: './table-list-tariff-select.component.html',
  styleUrl: './table-list-tariff-select.component.scss',
})
export class TableListTariffSelectComponent implements OnInit, OnChanges {
  constructor() {}

  @Input() dataSource: any[] = []
  @Input() columns: any[] = []
  @Output() selectItem = new EventEmitter<any>()
  @Output() deleteItem = new EventEmitter<any>()
  @Output() managerItem = new EventEmitter<any>()
  @Input() listSelected: any[] = []
  @Input() selected: any = {}
  @Input() multiSelect = false
  @Input() disabled = false

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<any>()

  ngOnInit() {
    if (this.dataSource.length > 0) {
      this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
      this.tableSource = new MatTableDataSource<any>(this.dataSource)
      this.updateTableDataSource()
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataSource']) {
      this.updateTableDataSource()
    }
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource
  }

  selectItemEvent(item: any): void {
    if (!this.disabled) {
      this.selectItem.emit(item)
    }
  }

  deleteItemEvent(item: any): void {
    this.deleteItem.emit(item)
  }

  checkSelect(element: any) {
    if (this.disabled) {
      return false
    } else {
      if (element.id && element) {
        if (this.multiSelect) {
          const index = this.listSelected.findIndex(
            (item) => item.id == element.id,
          )
          return index == -1 ? false : true
        } else {
          return element.id == this.selected.id
        }
      }
      return false
    }
  }

  managerItemEvent(item: any): void {
    this.managerItem.emit(item)
  }
}
